import React, { ReactElement, useEffect } from 'react';
import { useLocation, useParams } from 'react-router';
import { Loader } from 'idsk-react-components';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import SprievodnyDokumentList from '../../module/SprievodnyDokument/SprievodnyDokumentList';
import PageHeadingWithBackButton from '../../module/PageHeadingWithBackButton';
import routes from '../../routing/routes';
import {
  useLegislativnyMaterialDetail,
} from '../../module/LegislativnyMaterial/LegislativnyMaterialDetail';
import GlobalErrors from '../../module/GlobalErrors';
import Layout from '../Layout';
import SecuredPage from '../../module/SecuredPage';
import PracovnyKrokEnum from '../../model/pracovnyKrok/PracovnyKrokEnum';
import SuccessMessages from '../../module/SuccessMessages';
import useLegislativnyMaterialHistoria
  from '../../module/LegislativnyMaterial/LegislativnyMaterialHistoria/hooks/useLegislativnyMaterialHistoria';

const SprievodnyDokumentListPage = (): ReactElement => {
  const location = useLocation();
  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.SPRIEVODNY_DOKUMENT_FUNCTION);
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number, stadiumUuid: string }>();

  const {
    legMaterialHistoriaList,
    legMaterialHistoriaStatus,
  } = useLegislativnyMaterialHistoria(materialDetail?.uuid);

  function isPredbeznaInformacia(): boolean {
    return type === 'PI';
  }

  useEffect(() => {
    if (!legMaterialHistoriaStatus.loading && !materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [legMaterialHistoriaStatus.loading, materialStatus.loading]);

  return (
    <Layout>
      <>
        <Breadcrumbs routeList={[
          homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
          {
            heading: isPredbeznaInformacia() ? 'Predbežné informácie' : 'Legislatívne procesy',
            to: isPredbeznaInformacia() ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
          },
          {
            heading: `${type}/${year}/${index}`,
            to: routes.procesy.detail.withParams(type, year, index),
          },
          {
            heading: 'Sprievodná dokumentácia',
            to: location.pathname,
          }]}
        />
        <GlobalErrors />
        <Loader loading={materialStatus.loading || legMaterialHistoriaStatus.loading}>
          <SecuredPage
            requestStatus={materialStatus.responseCode}
          >
            <>
              <SuccessMessages />
              {materialDetail && legMaterialHistoriaList && (
                <>
                  <PageHeadingWithBackButton
                    headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                    heading="Sprievodná dokumentácia"
                    backLinkText={`Späť na ${materialDetail.cisloLegislativnehoMaterialu}`}
                    backLinkRoute={routes.procesy.detail.withParams(type, year, index)}
                  />
                  <SprievodnyDokumentList
                    materialDetail={materialDetail}
                    legMaterialHistoriaList={legMaterialHistoriaList}
                  />
                </>
              )}
            </>
          </SecuredPage>
        </Loader>
      </>
    </Layout>
  );
};

export default SprievodnyDokumentListPage;
